import { useTranslation } from 'react-i18next';
import config from '../../../../../../../../config';
import Tag from './styles';

function RoleTag(props: { role: number }) {
  const { role } = props;
  const { t } = useTranslation('widgets');
  switch (role) {
    case config.Roles.Admin:
      return (
        <Tag className="admin tag">
          {t('users.roles.admin')}
        </Tag>
      );

    case config.Roles.Owner:
      return (
        <Tag className="owner tag">
          {t('users.roles.owner')}
        </Tag>
      );

    case config.Roles.ExpertUser:
      return (
        <Tag className="expert-user tag">
          {t('users.roles.expert-user')}
        </Tag>
      );

    default:
      return (
        <Tag className="user tag">
          {t('users.roles.default')}
        </Tag>
      );
  }
}

export default RoleTag;
